import { autoinject, bindable, observable } from 'aurelia-framework';
import { ValidationController, ValidationControllerFactory, ValidationRules } from 'aurelia-validation';
import { 
	ServiceStructureService, 
	ServiceNodeModel 
} from "../service-structure-service";
import { RowValidationErrorModel } from "../../../models/row-validation-error-model";
import { ResourcedNotificationService, NotificationType } from "../../../components/notifications/notification-service";

@autoinject
export class BasicInfo {
	@bindable service: ServiceNodeModel;

	@observable serviceTitle: string;
	@observable serviceCode: string;

	submitting: boolean;
	hasErrors: boolean;
	errors: RowValidationErrorModel[];

	titleErrors = [];

	private validationController: ValidationController;

	constructor(
		private serviceStructureService: ServiceStructureService,
		private notificationService: ResourcedNotificationService,
		validationControllerFactory: ValidationControllerFactory) {

		this.validationController = validationControllerFactory.createForCurrentScope();

		this.submitting = false;
		this.hasErrors = false;

		ValidationRules
			.ensure((c: BasicInfo) => c.serviceTitle)
				.required()
			.withMessageKey('Service_BasicInfo_ValidationError_ServiceNameIsRequired')
			.ensure((c: BasicInfo) => c.serviceCode)
				.required()
				.withMessageKey('Service_BasicInfo_ValidationError_ServiceCodeIsRequired')
			.on(this);
	}

	private handleResponse(response: Response) {
		if (response.status === 200) {
			this.notificationService.push("ViewMessage_SaveSucceeded", NotificationType.Success);
			this.errors = null;
		} else {
			response.json().then((errors) => {
				this.notificationService.push("Label_ErrorInSubmit", NotificationType.Error);
				this.errors = RowValidationErrorModel.createFromValidationErrors(errors);
				this.hasErrors = true;
			});
		}
		this.submitting = false;
	}

	serviceChanged() {
		this.serviceTitle = this.service?.title;
		this.serviceCode = this.service?.code;
	}

	private updateServiceStructure() {
		this.serviceStructureService.updateServiceStructure(this.service).then(this.handleResponse.bind(this));
	}

	private updateService() {
		this.serviceStructureService.updateService(this.service).then(this.handleResponse.bind(this));
	}

	submit(): void {
		this.validationController.validate().then((result) => {
			if (!result.valid) {
				return;
			}

			this.submitting = true;
			this.hasErrors = false;

			this.service.title = this.serviceTitle;
			this.service.code = this.serviceCode;

			if (this.service.nodeType === ServiceStructureService.ServiceStructureNodeType) {
				this.updateServiceStructure();
			} else {
				this.updateService();
			}			
		});
	}
}
